/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import './deletefeedback.scss';
import FormDialog from '../../../Components/Modal/modal.js';
import alertIcon from '../../../Assets/images/svg/alert_icon.svg';
import { DELETE_DIALOG, CANCEL_TEXT } from '../../../Constants/strings.js';

const DeleteDialog = ({
  selectedItem,
  setRows,
  setIsDialogOpen,
  handleSnackbar,
  setIsEdit,
  handleCloseAction,
  handleDeleteAction,
}) => {
  const content = DELETE_DIALOG;

  return (
    <FormDialog
      open={selectedItem !== null}
      title={content.TITLE_TEXT1}
      PaperProps={{}}
      dialogCss="dialog-message"
      dialogPaperCss="delete-dialog-paper"
      width={360}
      height={205}
      dialogBodycontent={
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img className="icon-image" src={alertIcon} alt="" />
          </div>
          <div className="dialog-message-text">{content.DELETE_TEXT}</div>
        </div>
      }
      button1={CANCEL_TEXT}
      cancelButtonId={'cancel-' + content.BUTTON_ID}
      button2={content.BUTTON_TEXT}
      submitButtonId={content.BUTTON_ID}
      button2Action={() =>
        handleDeleteAction(
          selectedItem,
          setRows,
          setIsDialogOpen,
          handleSnackbar,
          setIsEdit,
        )
      }
      button1Action={() => handleCloseAction(setIsDialogOpen, setIsEdit)}
    />
  );
};

DeleteDialog.propTypes = {
  selectedItem: PropTypes.object,
  setRows: PropTypes.func.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  handleSnackbar: PropTypes.func.isRequired,
  setIsEdit: PropTypes.func.isRequired,
  handleCloseAction: PropTypes.func.isRequired,
  handleDeleteAction: PropTypes.func.isRequired,
};

export default DeleteDialog;
